import { AccountCircle } from '@mui/icons-material';
import { Avatar, Box, CircularProgress, Divider, Typography } from '@mui/material';
import React from 'react';

// Dummy data for the timeline
const dummyTimelineData = [
    {
        achievement_completed_at: '15 July',
        achievement_name: 'First Commit 2',
        photo_link: 'https://lh3.googleusercontent.com/a/AATXAJx3FY8iG5bJpF3i4sRTtoB5g-HT9fUnv2L-_N0G=s96-c',
        team_name: 'Software Development',
        username: 'Gabe'
    },
];

const AchievementsTimeline = ({ achievementsTimeline = dummyTimelineData, isAchievementsTimelineLoading = false }) => {

    return (
        <Box className="w-full h-full bg-white rounded-lg shadow-md p-5">
            {/* Header */}
            <Box className="mb-6">
                <Typography
                    variant="h6"
                    className="text-gray-800 font-semibold mb-2"
                    style={{ fontSize: '18px', fontWeight: 600 }}
                >
                    🎉 Latest Achievements
                </Typography>
                <Divider />
            </Box>

            {/* Timeline */}
            {isAchievementsTimelineLoading ? (
                <Box className="flex justify-center items-center h-full">
                    <CircularProgress color='primary' sx={{ mb: 1, width: '100%', borderRadius: '15px' }} />
                </Box>
            ) : achievementsTimeline.length > 0 ? (
                <Box className="relative">
                    {/* Timeline line - positioned relative to the wrapper */}
                    <Box className="absolute left-6 top-0 w-0.5 bg-gradient-to-b from-slate-700 to-sky-500" style={{ height: '100%' }}></Box>

                    {/* Scrollable content container */}
                    <Box className="overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-white" sx={{ maxHeight: '25em' }}>
                        {/* Timeline items */}
                        <Box className="space-y-6 pr-4 pb-2">
                            {achievementsTimeline.map((item, index) => (
                                <Box key={`${item.username}-${index}`} className="relative flex items-start">
                                    {/* Timeline dot */}
                                    <Box className="absolute left-4 w-4 h-4 bg-gradient-to-b from-slate-900 to-sky-900 rounded-full border-2 border-white shadow-md z-10"></Box>

                                    {/* Content */}
                                    <Box className="ml-12 flex-1">
                                        <Box className="flex items-start space-x-3">
                                            {/* User Avatar */}
                                            <Box className="flex-shrink-0">
                                                {item.photo_link ? (
                                                    <Avatar
                                                        src={item.photo_link}
                                                        alt={item.username}
                                                        className="w-10 h-10 border-2 border-gray-100 shadow-sm"
                                                    />
                                                ) : (
                                                    <Avatar className="w-10 h-10 bg-gradient-to-b from-slate-900 to-sky-900 border-2 border-gray-100 shadow-sm">
                                                        <AccountCircle />
                                                    </Avatar>
                                                )}
                                            </Box>

                                            {/* Achievement details */}
                                            <Box className="flex-1 min-w-0">
                                                <Typography
                                                    variant="body2"
                                                    className="text-gray-900 font-medium mb-1"
                                                    style={{ fontSize: '14px', fontWeight: 500 }}
                                                >
                                                    {item.username}
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    className="text-blue-600 font-semibold mb-1"
                                                    style={{ fontSize: '13px', fontWeight: 600 }}
                                                >
                                                    {item.achievement_name}
                                                </Typography>
                                                <Typography
                                                    variant="caption"
                                                    className="text-gray-600 mb-2 block"
                                                    style={{ fontSize: '12px', fontWeight: 400, lineHeight: '1.4' }}
                                                >
                                                    {item.team_name}
                                                </Typography>
                                                <Typography
                                                    variant="caption"
                                                    className="text-gray-500"
                                                    style={{ fontSize: '11px', fontWeight: 400 }}
                                                >
                                                    {item.achievement_completed_at}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                </Box>
            ) : (
                <Box className="flex justify-center items-center h-full">
                    <Typography variant="caption" className="text-gray-500">
                        No recent achievements yet.
                    </Typography>
                </Box>
            )}

            {/* Footer message */}
            <Box className="mt-6 pt-4 border-t border-gray-100">
                <Typography
                    variant="caption"
                    className="text-center text-gray-500 block"
                    style={{ fontSize: '11px', fontWeight: 400 }}
                >
                    Each achievement is a step towards greatness 🚀
                </Typography>
            </Box>
        </Box>
    );
};

export default AchievementsTimeline; 